// extracted by mini-css-extract-plugin
export default {"pointsAndRatingContainer":"BenefactorPointsAndRating_pointsAndRatingContainer__Myv9S","loadingContainer":"BenefactorPointsAndRating_loadingContainer__I6ftz"};